/**
 * Intents — the only way anything outside the sim can influence the world.
 *
 * An intent is a *request*, never an instruction. Design spec §9.2: "assume
 * hostile clients from day one." The envelope that arrives off the wire is
 * untyped, unvalidated and possibly malicious, so every handler runs the same
 * three steps before anything touches world state:
 *
 * 1. `parse` — is this the shape it claims to be? (untrusted → typed)
 * 2. `check` — is it legal *right now*, for this actor, in this world?
 * 3. `apply` — only then, mutate.
 *
 * Rejections are returned to the caller rather than thrown: one player's
 * malformed packet must not stall the tick for everyone else.
 */
/** Structural check on the envelope, before any handler sees it. */
export function isWellFormedEnvelope(value) {
    if (typeof value !== 'object' || value === null)
        return false;
    const intent = value;
    return (typeof intent.actorId === 'string' &&
        intent.actorId.length > 0 &&
        typeof intent.type === 'string' &&
        intent.type.length > 0 &&
        typeof intent.tick === 'number' &&
        Number.isInteger(intent.tick) &&
        intent.tick >= 0);
}
//# sourceMappingURL=intent.js.map